<template>
  <div class="wrap-carousel">
    <b-carousel
      indicators
    >
      <b-carousel-slide
        v-for="(banner, i) in banners"
        :key="i"
       
      >
        <template v-slot:img>
          <a :href="banner.link" target="_blank" rel="noopener noreferrer">
            <img
              :src="`${baseURL}/storage/app/img/banner/${banner.banner_picture_sm}`"
              data-loading="xxx.jpg"
              style="width: 100vw;"
              class="wrap-carousel--small"
            >
            <img
              :src="`${baseURL}/storage/app/img/banner/${banner.banner_picture}`"
              data-loading="xxx.jpg"
              style="width: 100vw;"
              class="wrap-carousel--desktop"
            >
          </a>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  computed: {
    ...constantsComputed,
    ...mapState({
      banners: state => state.banner.data
    })
  },

  methods: {
    getBannerApi () {
      let routeName = this.$route.name
      if (routeName === 'winnerArchive') {
        routeName = 'winners'
      }
      if (routeName === 'programArchive') {
        routeName = 'archive'
      }
      if (routeName === 'privacy') {
        routeName = 'archive'
      }
      if (!this.banners) {
        this.$store.dispatch('banner/get', routeName)
      }
    }
  },

  created () {
    this.getBannerApi()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-carousel {
  width: 100%;

  &--small {
    @media only screen and (min-width: $break-l) {
      display: none;
    }
  }

  &--desktop {
    display: none;

    @media only screen and (min-width: $break-l) {
      display: block;
    }
  }
}
</style>
